import React from 'react';

function StaffListingHeading() {
  return (
    <div className="staff-listing-heading">
      <div className="name-container">Name</div>
      <div className="contact-container">Contact</div>
    </div>
  );
}

export default StaffListingHeading;
